<template>
  <div class="main">
    <c-panel>
      <form-recurso :paramId="$route.params.id" v-on:onSubmitRecurso="onSubmitRecurso"></form-recurso>
    </c-panel>
  </div>
</template>
<script>
import formRecurso from "./form"

export default {
  methods: {
    onSubmitRecurso () {
      this.$router.push('/admin/financeiro/recurso')
    }
  },
  components: { formRecurso }
}
</script>

